import amaLog from '../helpers/log';
import { capitalizeFirst, isEmpty } from '../helpers/utils';
import { getPageType } from './device';
/////////////////
import { getModules } from '../modules/index';
/////////

/////////////////
/////////////////////////////////////////////////////
/////////
/////////////////
//////////////////////////////////////////////////////
/////////

const patternRegularSubdomain = /^(?!(?:www|dev|local|test|stage)).*$/;

let amaSite: string = undefined;
let amacc: string = undefined;
let amaHost: string = undefined;
let amaDomain: string = undefined;
let amaSubDomain: string = undefined;
let amaTestSite: string = undefined;
let pathIdExceptions: Record<string, string> = {};

export const isVideoPage = (): boolean => ['/video/','/video-slug/'].some( p => window?.location?.pathname?.includes(p));

const patternSubdomain = /^(\w+\.\w+\.\w+)$/m;
/**
 * Check if the current location.host is a regular (www) subdomain
 * or a blog
 * @return {boolean}
 */
export const hostIsSpecificSubdomain = (): boolean =>
  patternSubdomain.test(window.location.host) && patternRegularSubdomain.test(window.location.host);

export const isBlog = hostIsSpecificSubdomain;

const getCategory = (): string => location.pathname.split('/')[1] || 'general';

const getTestSite = (): undefined | string => {
  if (amaTestSite) return amaTestSite;
  const testSiteCookie = 'adsDfpIdTestSite';

  if (window?.location?.search) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('dfp_id')) {
      const dfpId: string = urlParams.get('dfp_id');
      if (dfpId.length > 0) {
        amaTestSite = dfpId;
        sessionStorage.setItem(testSiteCookie, amaTestSite);
      }
    }
  } else if (sessionStorage.getItem(testSiteCookie)) {
    const dfpId: string = sessionStorage.getItem(testSiteCookie);
    if (dfpId.length > 0) {
      amaTestSite = dfpId;
    }
  }
  return amaTestSite;
};

export const isTestSite = (): boolean => amaTestSite !== undefined;

export const getHostName = (): string => amaHost;

export const getSiteName = (): string => amaSite;

export const isSubDomain = (): boolean => !!amaSubDomain;

const containsCategoryPath = () => location.pathname.split('/')[1] !== '';

export const resolveHost = (adScriptConfHost?: string) => {
  const winDefinedHost = window.ama?.hostName || window.hostName;

  amaLog('resolveHost optHost definedHost', adScriptConfHost, winDefinedHost);

  const host =
    (!isEmpty(winDefinedHost) && winDefinedHost) ||
    (!isEmpty(adScriptConfHost) && adScriptConfHost) ||
    window.location.hostname;
  const parts = host.split('.');
  const secondLevelDomain = parts.length > 1 ? parts[parts.length - 2] : undefined;
  const topLevelDomain = parts.length > 0 ? parts[parts.length - 1] : undefined;

  const definedSubDomain = window.ama?.subDomain || window.subDomain;
  // Use subdomain if defined by the site
  const useSub = !isEmpty(definedSubDomain);

  const domainName = secondLevelDomain ? `${secondLevelDomain}.${topLevelDomain}` : undefined; // elle.se
  const subDomainName = useSub && domainName ? `${definedSubDomain}.${domainName}` : undefined; // elsa.elle.se

  amaHost = subDomainName || domainName || undefined; // elsa.elle.se / elle.se
  amaSite = (useSub && definedSubDomain) || secondLevelDomain; // elsa / elle
  amaDomain = domainName || undefined; // elle.se
  amaSubDomain = definedSubDomain || undefined; // elsa

  if (!amaHost || !amaSite) {
    console.error(`Ads bundle failed resolve amaHost: ${amaHost} and/or amaSite: ${amaSite}`);
  }

  amaLog('resolveHost ', parts, amaSite, amaHost, amaDomain, amaSubDomain);
};

export const getDomain = (): string => {
  if (!isEmpty(amaDomain)) return amaDomain;

  amaLog('getDomain', amaDomain);

  return amaDomain;
};

export const getSubdomainAdwatchName = (): string => {
  const components = amaHost.split('.');
  if (components.length !== 3) {
    throw Error(`Unexpected length of amaHost ${amaHost}`);
  }
  const [subdomain, domain] = components;
  const capitalizedDomain = capitalizeFirst(domain);
  return `${subdomain}${capitalizedDomain}`;
};

export const setDfpSection = (section: string | undefined = window.ama?.dfpSection): string => {
  let dfpSection = 'general'; // elle.se
  const pageType = getPageType();
  let useNewAdUnitPath = false;
///////////////////
  ({ useNewAdUnitPath } = getModules());
///////////

  const cc = resolveCountryCode();
  const catSection = (category: string) => {
    if (useNewAdUnitPath) { 
      return (dfpSection = pageType === 'article' ? `${category}/article` : `${category}/category_front`);
    }
    else if (cc === 'no') {
      const catEnd = pageType === 'article' ? 'artikkel' : 'seksjonsfront';
      return (dfpSection = `seksjoner/${category}/${catEnd}`);
    } else return (dfpSection = pageType === 'article' ? `${category}/article` : category);
  };

  if (section) {
    dfpSection = section;
  } else if (isSubDomain()) {
    dfpSection = useNewAdUnitPath ? `blog/${amaSubDomain}` : amaSubDomain;
  } else if (containsCategoryPath()) {
    const category = getCategory();
    dfpSection = catSection(category);
  } else if (pageType === 'front' && !isSubDomain()) {
    if (useNewAdUnitPath) {
      dfpSection = 'frontpage/front';
    } else dfpSection = cc === 'no' ? 'forside' : 'front';
  }

  amaLog('dfpSection', dfpSection);
  return dfpSection;
};

export const resolveAdUnitPathGamSiteId = (configGamSiteId: string = 'global') => {
  let resolveId = configGamSiteId;
  const testSite = getTestSite();
///////////////////
///////////////////////////////////////////
///////////

///////////////////
///////////////////////////////////////////////////////////////////////////////////////////////
///////////

  if (testSite) {
    resolveId = testSite;
  } else if (amaDomain && pathIdExceptions[amaDomain]) {
    resolveId = pathIdExceptions[amaDomain];
  } else if (resolveId.includes('global') || isSubDomain()) {
    resolveId = getDomain();
  }

  amaLog(`adUnitPathGamSiteId: /${resolveId}/`);

  return resolveId;
};

export const getVideoAdUnitPath = (config: any, videoOnly: boolean, adSettings: any): string => {
  let sitePath = isBlog() ? `${config.gamSiteId}/${adSettings.siteName}` : config.gamSiteId;
  let categoryPath = '';

///////////////////
/////////////////////////////////////////////
///////////////////////////////////////////////////
/////////////////////////////////////////////
/////
//////////////////////////////////////////////////////////////////////////////
///////////
  
///////////////////
    categoryPath = videoOnly ? 'videopage' : (adSettings.firstVideoAutoStart === false ? 'video/clicktoplay' : 'video/autoplay');
///////////
  return `/${config.networkCode}/${sitePath}/${categoryPath}`;
}

export const resolveCountryCode = (): string => {
  if (typeof amacc !== 'undefined') return amacc;

  if (amaHost) {
    const exceptions: { [key: string]: string } = { 'mabra.com': 'mabra.se' };

    amacc = (exceptions[amaHost] ?? amaHost).split('.').pop();
  }

  amaLog('resolveCountryCode calculated ... ', amacc);

  return amacc;
};
export const isFinishSite = (): boolean => getSiteName() === 'seiska';

export const isSeOcelot = (): boolean => {
  let host: string = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();

  if (host.startsWith('www.')) {
    host = host.slice(4);
  }

  if (host === 'mabra.com') return true;

  const parts: string[] = host.split('.');

  if (parts.length !== 2) return false;

  const [siteName, tld] = parts;

  return tld === 'se' && siteName !== 'recept';
};
